import * as React from "react";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import DocumentsGrid from "./DocumentsGrid";
import DataGrid from "../../app/grid/DataGrid";
import { ColumnProps } from "antd/lib/table";
import { Spin } from "antd";

export interface Props {
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  translate: any;
  onExpandReportingPeriod: any;
  formTypesLoader?: boolean;
  formVersionDocumentsPresenter?: any;
}

export interface State {}

export default class ApplicantDocumentsGrid extends React.Component<
  Props,
  State
> {
  render() {
    const {
      reportingPeriods,
      translate,
      onExpandReportingPeriod,
      formTypesLoader,
      formVersionDocumentsPresenter
    } = this.props;

    let columns: ColumnProps<any>[] = [
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.reporting_period_name"
        ),
        dataIndex: "reportingPeriodName",
        key: "reportingPeriodName"
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.reporting_type_name"
        ),
        dataIndex: "reportingTypeName",
        key: "reportingTypeName"
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.start_period"
        ),
        dataIndex: "fromPeriod",
        key: "fromPeriod",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.fromPeriod,
            b.fromPeriod
          ) as any
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.end_period"
        ),
        dataIndex: "toPeriod",
        key: "toPeriod",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.toPeriod, b.toPeriod) as any
      }
    ];

    const expandedRowRender = (record, index, indent, expanded) => {
      return (
        <Spin spinning={formTypesLoader ? true : false}>
          {formVersionDocumentsPresenter && (
            <DocumentsGrid {...formVersionDocumentsPresenter}></DocumentsGrid>
          )}
        </Spin>
      );
    };

    return (
      <DataGrid
        title={translate("form_version_document_form.title")}
        translate={translate}
        columns={columns}
        dataSource={reportingPeriods}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={onExpandReportingPeriod}
      />
    );
  }
}
